import React from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/Legal.css";

const Licensing = () => {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <div className="logo" onClick={() => navigate("/")}>
        TOEICMON
      </div>

      <div className="legal-content">
        <div className="legal-header">
          <h1>라이센스 정보</h1>
          <p>최종 업데이트: 2024년 5월 1일</p>
        </div>

        <div className="legal-sections">
          <section className="legal-section">
            <h2>1. 라이센스 부여</h2>
            <p>
              토익몬은 이용 약관에 따라 개인적, 비상업적 목적으로 플랫폼을
              이용하고 접근할 수 있는 제한적, 비독점적, 양도 불가능한 라이센스를
              부여합니다.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. 이용권 라이센스</h2>
            <p>
              2.1. 귀하의 이용권은 유효 기간 동안 토익몬의 콘텐츠와 기능에 대한
              접근을 제공합니다.
            </p>
            <p>
              2.2. 이 라이센스는 개인적이며 타인과 공유하거나 양도할 수
              없습니다.
            </p>
          </section>

          <section className="legal-section">
            <h2>3. 콘텐츠 사용 권한</h2>
            <p>
              3.1. 문제, 설명, 학습 자료, 모의 테스트를 포함한 토익몬을 통해
              제공되는 모든 콘텐츠는 판매가 아닌 라이센스로 제공됩니다.
            </p>
            <p>
              3.2. 서비스나 콘텐츠의 어떤 부분도 복사, 수정, 배포, 판매 또는
              대여할 수 없습니다.
            </p>
          </section>

          <section className="legal-section">
            <h2>4. 지적 재산권</h2>
            <p>
              4.1. 토익몬을 통해 제공되는 모든 콘텐츠와 자료는 저작권, 상표권 및
              기타 지적 재산권법에 의해 보호됩니다.
            </p>
            <p>
              4.2. 귀하는 토익몬이 플랫폼과 콘텐츠에 대한 모든 권리, 소유권 및
              이익을 보유함을 인정합니다.
            </p>
          </section>

          <section className="legal-section">
            <h2>5. 제한 사항</h2>
            <p>5.1. 상업적 목적으로 콘텐츠를 사용할 수 없습니다.</p>
            <p>
              5.2. 플랫폼의 소스 코드를 디컴파일, 역설계하거나 접근을 시도해서는
              안 됩니다.
            </p>
            <p>5.3. 토익몬 콘텐츠를 기반으로 파생 작업을 만들 수 없습니다.</p>
          </section>

          <section className="legal-section">
            <h2>6. 제3자 콘텐츠</h2>
            <p>
              6.1. 토익몬의 일부 콘텐츠는 제3자로부터 라이센스를 받을 수
              있습니다.
            </p>
            <p>6.2. 모든 제3자 콘텐츠는 해당 소유자의 재산으로 남습니다.</p>
          </section>

          <section className="legal-section">
            <h2>7. 라이센스 종료</h2>
            <p>7.1. 이 약관을 위반하면 라이센스는 자동으로 종료됩니다.</p>
            <p>
              7.2. 토익몬은 언제든지 어떤 이유로든 라이센스를 종료할 권리를
              보유합니다.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. 연락처 정보</h2>
            <p>
              라이센스 관련 문의나 질문이 있으시면 support@toeicmon.com으로
              연락해 주세요.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Licensing;
